export function Metodologia() {
  return (
    <>
      <div className="topbar">
        <h1>Como funciona</h1>
      </div>
      <div className="content">
        <div className="card card-pad" style={{ lineHeight: 1.7 }}>
          <h2 style={{ marginBottom: 10 }}>Cálculo de previsão e atraso</h2>
          <p>
            Cada linha de produto tem uma <b>data de abertura</b>. A partir dela, a previsão de
            cada etapa é calculada pelo <b>método do caminho crítico</b>: uma etapa só começa
            depois que <b>todas</b> as etapas das quais depende terminam; etapas sem dependência
            entre si correm em paralelo.
          </p>
          <p>
            Enquanto uma etapa está <i>não iniciada</i>, a previsão é recalculada a cada dia — se
            as anteriores já terminaram e ela ainda não começou, o atraso aparece sozinho, sem
            ninguém precisar preencher nada.
          </p>
          <h3 style={{ margin: '18px 0 8px' }}>Fases e dependências</h3>
          <p>
            <b>PD1 e PD2</b> seguem a cadeia original. Dentro de <b>PD3</b>, as 9 etapas rodam em
            paralelo, começando assim que PD1 libera (etapas 5, 6 e 7 prontas). <b>PD4</b> só
            começa depois de todo o PD3 e o PD2; suas 3 etapas correm em paralelo. <b>PD5</b> só
            começa depois de todo o PD4. Isso dá um caminho crítico padrão de ~168 dias corridos.
          </p>
          <h3 style={{ margin: '18px 0 8px' }}>Definições do painel de atrasos</h3>
          <p>
            <b>Atraso da linha</b>: diferença entre a previsão de conclusão atual e a previsão de
            base (calculada no dia da abertura), em dias corridos. <b>Atraso de uma etapa</b>: se
            concluída, o quanto durou a mais do que o previsto; se não concluída, o quanto está
            parada além do momento em que já poderia ter começado.
          </p>
          <h3 style={{ margin: '18px 0 8px' }}>Perfis de acesso</h3>
          <p>
            <b>Administrador</b> gerencia usuários, produtos e tudo mais. <b>Gestor/PMO</b> vê e
            edita tudo, sem gerir usuários. <b>Editor</b> marca status e datas apenas das etapas
            da sua área e preenche os blocos da ficha que competem a ela. <b>Leitor</b> só
            visualiza. As permissões são garantidas no banco (RLS), não apenas na tela.
          </p>
        </div>
      </div>
    </>
  );
}
